module.exports = __webpack_public_path__ + "static/img/news8-cover.a721f3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news8-cover.jpg
// module id = i84X
// module chunks = 0